import { c as _c } from "react/compiler-runtime";
// https://github.com/vercel/next.js/blob/canary/packages/third-parties/src/google/gtm.tsx

import { useEffect } from "react";
import Script from "next/script";
export type GTMParams = {
  gtmId: string;
  dataLayer?: string[];
  dataLayerName?: string;
  auth?: string;
  preview?: string;
};
let currDataLayerName: string | undefined = undefined;
export function GoogleTagManager(props) {
  const $ = _c(13);
  const {
    gtmId,
    dataLayerName: t0,
    auth,
    preview,
    dataLayer
  } = props;
  const dataLayerName = t0 === undefined ? "dataLayer" : t0;
  const gtmLayer = dataLayerName !== "dataLayer" ? `$l=${dataLayerName}` : "";
  const gtmAuth = auth ? `&gtm_auth=${auth}` : "";
  const gtmPreview = preview ? `&gtm_preview=${preview}&gtm_cookies_win=x` : "";
  let t1;
  let t2;
  if ($[0] !== dataLayerName) {
    t1 = () => {
      if (currDataLayerName === undefined) {
        currDataLayerName = dataLayerName;
      }
    };
    t2 = [dataLayerName];
    $[0] = dataLayerName;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(_temp, t3);
  let t4;
  if ($[4] !== dataLayer) {
    t4 = dataLayer ? `w[l].push(${JSON.stringify(dataLayer)})` : "";
    $[4] = dataLayer;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `
      (function(w,l){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        ${t4}
      })(window,'${dataLayerName}');`;
  let t6;
  if ($[6] !== t5) {
    t6 = <Script id="_next-gtm-init" dangerouslySetInnerHTML={{
      __html: t5
    }} />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = `https://www.googletagmanager.com/gtm.js?id=${gtmId}${gtmLayer}${gtmAuth}${gtmPreview}`;
  let t8;
  if ($[8] !== t7) {
    t8 = <Script id="_next-gtm" data-ntpc="GTM" src={t7} />;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t8) {
    t9 = <>{t6}{t8}</>;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
}
function _temp() {
  performance.mark("mark_feature_usage", {
    detail: {
      feature: "next-third-parties-gtm"
    }
  });
}